import { graphql } from "relay-runtime"

export const deDeleteBodyMeasurementMutation = graphql`
  mutation deDeleteBodyMeasurementMutation($input: De_deleteBodyMeasurementInput!, $connections: [ID!]!) {
    deleteBodyMeasurement: de_deleteBodyMeasurement(input: $input) {
      errors {
        ... on Error {
          message
        }
      }
      bodyMeasurement {
        id @deleteEdge(connections: $connections)
      }
    }
  }
`
